import {
  subdivisionColumns,
  taxParcelColumns,
  salesColumns,
  addressColumns,
} from "./resultsColumns";
import { BaseConfig } from "mcmap-lib";
export const AppConfig: BaseConfig = {
  application: {
    nouns: {
      plural: "",
      singular: "",
    },
  },
  useSearch: true,
  header: {
    title: "Athena - Public Property Search Viewer",
    subtitle: "McHenry County, Illinois",
    logoUrl: "assets/Athena_owlLogo.png",
    showScaleDropdown: true,
    email: "gis@mchenrycountyil.gov",
    sourcesUrl:
      "https://www.mchenrycountygis.org/athena/sources/Athena%20Sources.pdf",
  },

  googleAnalytics: {
    publicMeasurementId: "G-BMQG8FRF0J",
    internalMeasurementId: "G-5X1SXSYKLS",
  },

  authenticationService: {
    useAuth: false,
    arcGISAppname: "",
    prodAppUrl: "",
  },

  streetsBasemap: {
    id: "street",
    title: "Street",
    basemapLayers: [
      `https://www.mchenrycountygis.org/arcgis/rest/services/basemap/MapServer`,
      `https://www.mchenrycountygis.org/arcgis/rest/services/roadcenterlines/MapServer`,
      // {
      //   type: "vector-tile",
      //   url: "https://tiles.arcgis.com/tiles/6iYC5AXXYapRVNzl/arcgis/rest/services/Basemap/VectorTileServer"
      // },
      // {
      //   type: "vector",
      //   url: "https://tiles.arcgis.com/tiles/6iYC5AXXYapRVNzl/arcgis/rest/services/Basemap/VectorTileServer",
      // },
      // {
      //   type: "vector",
      //   url: "https://tiles.arcgis.com/tiles/6iYC5AXXYapRVNzl/arcgis/rest/services/Road_Centerlines/VectorTileServer",
      // }
    ],
    scaleBasemapLayers: [
      {
        type: "map-image",
        url: `https://www.mchenrycountygis.org/arcgis/rest/services/basemapdyn/MapServer`,
      },
      {
        type: "map-image",
        url: `https://www.mchenrycountygis.org/arcgis/rest/services/roadcenterlinesdyn/MapServer`,
      },
    ],
  },

  mapOptions: {
    extent: {
      xmin: 883329.649957926,
      ymin: 1988419.8842694,
      xmax: 1020953.51242933,
      ymax: 2131992.8736293,
      spatialReference: { wkid: 3435 },
    },
    constraints: {
      geometry: {
        xmin: 870000,
        ymin: 1900000,
        xmax: 1100000,
        ymax: 2200000,
        spatialReference: { wkid: 3435 },
      },
      minZoom: 2,
      maxZoom: 19,
    },
    useHighlightLayer: true,
  },

  printOptions: {
    headerTextColor: [0, 0, 0],
    sectionHeaderTextColor: [207, 167, 98],
    tableHeaderBackgroundColor: [78, 78, 78],
    tableHeaderTextColor: [255, 255, 255],
    allowDataPrint: true,
    excludeDisclaimer: false,
    showLegendOption: true,
    showScaleExtentOption: false,
    showFormatOptions: false,
    printServiceUrl:
      "https://www.mchenrycountygis.org/arcgis/rest/services/Printing/MchenryCustomPrint/GPServer/Export%20Web%20Map",
    // printServiceUrl:
    //   "https://www.mchenrycountygis.org/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task",
    summaryExportFields: [
      {
        field: "ParcelNumber",
        label: "Parcel Number",
      },
      { field: "Township", label: "Township" },
      { field: "TaxCode", label: "Tax Code" },
      { field: "TaxStatus", label: "Tax Status" },
      { field: "PropertyClass", label: "Property Class" },
      { field: "AssessedValue", label: "Assessed Value" },
      { field: "Owner", label: "Owner" },
      { field: "MailToAddress1", label: "Mail to Address" },
      { field: "MailToCity", label: "Mail to City" },
      { field: "SiteAddress", label: "Site Address Street" },
      { field: "SiteCity", label: "Site Address City" },
      { field: "ParcelArea", label: "Parcel Area" },
    ],
  },

  primaryLayer: {
    id: "parcels",
    title: "Tax Parcels",
    definitionExpression: "1=1",
    url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/parcels_wedge/MapServer/",
    visible: true,
    sublayers: [
      {
        id: 0,
        popupTemplate: {
          title: "Parcel: {ParcelNumber}",
          outFields: [
            "ParcelNumber",
            "SiteAddress",
            "SiteAddressCity",
            "Township",
            "Owner",
          ],
          content: (feature) => {
            const attributes = feature.graphic.attributes;
            const getFormattedFieldInfo = (label, field) => {
              if (attributes[field] && attributes[field] !== "") {
                return `<p style="margin:0;"><b>${label}:</b> <span>${attributes[field]}</span></p>`;
              }
              return "";
            };
            const fields = [
              { label: "Site Address", field: "SiteAddress" },
              { label: "Site Address City", field: "SiteAddressCity" },
              { label: "Township", field: "Township" },
              { label: "Owner", field: "Owner" },
            ];

            return fields
              .map((field) => getFormattedFieldInfo(field.label, field.field))
              .join("");
          },
        },
      },
    ],
  },

  secondaryLayers: [
    {
      id: "parcelAnnotation",
      title: "Parcel Text",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/parcelanno/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: false,
      allowedWithLayers: ["*"],
      allowTransparencyChange: false,
      groupLayers: [],
    },
    {
      id: "parcelSales",
      title: "Parcel Sales",
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/Parcel_Sales_Wedge/MapServer",
      // url: "https://tiles.arcgis.com/tiles/6iYC5AXXYapRVNzl/arcgis/rest/services/Parcel_Sales_Wedge/VectorTileServer",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["*"],
      allowTransparencyChange: false,
      groupLayers: [],
    },
    {
      id: "farmland",
      title: "Farm Assessment",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/farmland/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
      groupLayers: [
        {
          id: "farmlandcurrent",
          title: "Farm Assessment (Current)",
          url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/farmland/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2017",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "farmland2017",
          title: "Farm Assessment (2017)",
          url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/farmland_2017/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2017",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "farmland2019",
          title: "Farm Assessment (2019)",
          url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/farmland_2019/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2017",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "farmland2021",
          title: "Farm Assessment (2021)",
          url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/farmland_2021/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2017",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
      ],
    },
    {
      id: "soils",
      title: "Soil",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/soils/MapServer",
      scaleUrl:
        "https://www.mchenrycountygis.org/ArcGIS/rest/services/soilsdyn/MapServer",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
      groupLayers: [],
      allowedWithLayers: ["*"],
      notAllowedWithLayers: ["hydricsoils"],
    },
    {
      id: "hydricsoils",
      title: "Hydric Soil",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/Hydric_soils/MapServer",
      scaleUrl:
        "https://www.mchenrycountygis.org/ArcGIS/rest/services/HydricSoilsdyn/MapServer",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
      groupLayers: [],
      allowedWithLayers: ["*"],
      notAllowedWithLayers: ["soils"],
    },
    {
      id: "floodZones",
      title: "FEMA Flood Zones",
      url: "https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer",
      scaleUrl:
        "https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: [
        "wetlands",
        "topography",
        "topography2017",
        "topography2022",
        "historicalFloodZone",
      ],
      allowTransparencyChange: true,
      sublayers: [
        { visible: true, id: 1 },
        // { visible: true, id: 3 },
        { visible: true, id: 14 },
        { visible: true, id: 19 },
        { visible: true, id: 20 },
        { visible: true, id: 27 },
        { visible: true, id: 28 },
        // { visible: true, id: 34 },
      ],
      groupLayers: [],
    },
    {
      id: "historicalFloodZone",
      title: "Historical Flood Zones",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/Flood_of_Records/MapServer",
      scaleUrl: "",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: [
        "wetlands",
        "topography",
        "topography2017",
        "topography2022",
        "floodZones",
      ],
      allowTransparencyChange: true,
      groupLayers: [],
    },
    {
      id: "wetlands",
      title: "ADID Wetlands",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/wetlands/MapServer",
      scaleUrl:
        "https://www.mchenrycountygis.org/ArcGIS/rest/services/wetlandsdyn/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["floodZones", "historicalFloodZone"],
      allowTransparencyChange: true,
      groupLayers: [],
    },
    {
      id: "nrcs_wetlands",
      title: "NRCS Wetlands",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/Planning/NRCS_Wetlands/MapServer",
      scaleUrl:
        "https://www.mchenrycountygis.org/ArcGIS/rest/services/Planning/NRCS_Wetlandsdyn/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["*"],
      allowTransparencyChange: true,
      groupLayers: [],
    },
    {
      id: "huc_watersheds",
      title: "HUC Watersheds",
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/Planning/HUC_Watershed/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
      groupLayers: [
        {
          id: "HUC_8_Watersheds",
          title: "HUC 8 Watersheds",
          url: "https://www.mchenrycountygis.org/arcgis/rest/services/Planning/HUC_8_Watersheds/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2022",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "HUC_10_Watersheds",
          title: "HUC 10 Watersheds",
          url: "https://www.mchenrycountygis.org/arcgis/rest/services/Planning/HUC_10_Watersheds/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2022",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "HUC_12_Watersheds",
          title: "HUC 12 Watersheds",
          url: "https://www.mchenrycountygis.org/arcgis/rest/services/Planning/HUC_12_Watersheds/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2022",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
        {
          id: "HUC_Watersheds",
          title: "All HUC Watersheds",
          url: "https://www.mchenrycountygis.org/arcgis/rest/services/Planning/HUC_Watershed/MapServer",
          type: "map-image",
          visible: false,
          opacity: 1,
          showInTOC: false,
          showInLegend: true,
          allowedWithLayers: [
            "soils",
            "hydricsoils",
            "wetlands",
            "topography",
            "topography2022",
            "floodZones",
            "historicalFloodZone",
          ],
          allowTransparencyChange: true,
        },
      ],
    },
    {
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/Fox_Waterways/Fox_Waterways/MapServer",
      id: "foxWaterways",
      title: "Fox Waterways",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
      allowedWithLayers: ["*"],
    },
    {
      id: "fireDistricts",
      title: "Fire Districts",
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/Taxing_Districts/Fire_Districts/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowTransparencyChange: true,
    },
    {
      id: "topography",
      title: "Topography 2008",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/topography/MapServer",
      scaleUrl: "",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["floodZones"],
      zoomToLayer: true,
      allowTransparencyChange: true,
      groupLayers: [],
      goToMiddleScale: true,
    },
    {
      id: "topography2017",
      title: "Topography 2017",
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/topography2017/MapServer",
      scaleUrl: "",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["floodZones"],
      zoomToLayer: true,
      allowTransparencyChange: true,
      groupLayers: [],
      goToMiddleScale: true,
    },
    {
      id: "topography2022",
      title: "Topography 2022",
      url: "https://www.mchenrycountygis.org/arcgis/rest/services/topography2022/MapServer",
      scaleUrl: "",
      type: "tile",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: true,
      allowedWithLayers: ["floodZones"],
      zoomToLayer: true,
      allowTransparencyChange: true,
      groupLayers: [],
      goToMiddleScale: true,
    },

    {
      id: "subdivisions",
      title: "Subdivision",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/subdivisions/MapServer",
      type: "map-image",
      visible: false,
      opacity: 1,
      showInTOC: true,
      showInLegend: false,
      allowTransparencyChange: true,
      groupLayers: [],
    },
    {
      id: "cityNames",
      title: "City Names",
      url: "https://www.mchenrycountygis.org/ArcGIS/rest/services/citynames/MapServer",
      type: "map-image",
      visible: true,
      opacity: 1,
      showInTOC: false,
      showInLegend: false,
    },
  ],
  searchOptions: {
    useClientLayer: false,
  },

  rendererOptions: {},

  resultsOptions: {
    title: "Tax Parcels (click rows to zoom)",
    includePagination: true,
    isSelectable: false,

    columnLookup: {
      parcel: taxParcelColumns,
      address: addressColumns,
      owner: taxParcelColumns,
      subdivision: subdivisionColumns,
      sales: salesColumns,
    },
    // tableSizeLookup: {
    //   parcel: "100vw",
    //   address: "100vw",
    //   owner: "100vw",
    //   subdivision: "",
    //   sales: "",
    // },
    fields: [
      {
        label: "",
        isButton: true,
        buttonLabel: "Show Details",
        size: 2,
        isVisible: true,
        canExport: false,
        field: "ShowDetails",
      },
      {
        field: "ParcelNumber",
        label: "Parcel Number",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "Township",
        label: "Township",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "TaxCode",
        label: "Tax Code",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "TaxStatus",
        label: "Tax Status",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "PropertyClass",
        label: "Property Class",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "AssessedValue",
        label: "Assessed Value",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "NetTaxableValue",
        label: "Net Taxable Value",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "TaxRate",
        label: "Tax Rate",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "TotalTax",
        label: "Total Tax",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "Owner",
        label: "Owner",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "MailToAddress 1",
        label: "Mail To Address 1",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "MailToAddress 2",
        label: "Mail To Address 2",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "MailToCity",
        label: "Mail To City",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "SiteAddressStreet",
        label: "Site Address Street",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "SiteAddressCity",
        label: "Site Address City",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "DocumentNumber",
        label: "Document Number",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "ParcelArea",
        label: "ParcelArea",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
      {
        field: "Location",
        label: "Location",
        size: 3.5,
        isVisible: true,
        canExport: true,
      },
    ],
  },

  reportOptions: {},

  toolbarOptions: {
    visibleTools: {
      search: true,
      select: true,
      grid: true,
      clear: true,
      zoom: true,
      pan: true,
      extent: true,
      fullScreen: true,
      markup: true,
      legend: true,
      print: true,
      trimap: true,
      buffer: true,
      results: true,
      measure: true,
      layers: true,
      parcelDetails: true,
      basemap: true,
      xy: true,
      scale: true,
    },
    initiallyVisibleTools: {
      layers: true,
    },
  },
  parcelLimit: 3000,
  numberOfTypeAheadResults: 8,
};
